import { render, staticRenderFns } from "./PublishUploadField.vue?vue&type=template&id=2707f7f5&scoped=true"
import script from "./PublishUploadField.vue?vue&type=script&lang=js"
export * from "./PublishUploadField.vue?vue&type=script&lang=js"
import style0 from "./PublishUploadField.vue?vue&type=style&index=0&id=2707f7f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707f7f5",
  null
  
)

export default component.exports